import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AccountDto, SiteDto } from '@dto';

@Injectable({ providedIn: 'root' })
export class TreeService {
  private _doNotChangeRoute = false;
  get doNotChangeRoute(): boolean {
    return this._doNotChangeRoute;
  }
  set doNotChangeRoute(value: boolean) {
    this._doNotChangeRoute = value;
  }

  private readonly selectSiteInListEmitter = new Subject<SiteDto>();
  selectSiteInList$ = this.selectSiteInListEmitter.asObservable();

  private readonly selectAccountInListEmitter = new Subject<AccountDto>();
  selectAccountInList$ = this.selectAccountInListEmitter.asObservable();

  private readonly deselectAllEmitter = new Subject<void>();

  private readonly enableFilterInputEmitter = new Subject<boolean>();
  enableFilterInput$ = this.enableFilterInputEmitter.asObservable();

  selectSiteInList(site: SiteDto): void {
    this.selectSiteInListEmitter.next(site);
  }

  selectAccountInList(account: AccountDto): void {
    this.selectAccountInListEmitter.next(account);
  }

  deselectAll(): void {
    this.deselectAllEmitter.next();
  }
}
